export default __webpack_public_path__ + "static/media/send-email.787613b7.svg";